import { ACADEMY_COURSE_UPDATE_TOPIC } from '../graphql/mutations/topic'
import { UPDATE_TOPIC, TOPIC_UPDATE_TAGS, CREATE_TOPIC, REMOVE_TOPIC } from '~/graphql/mutations/topic'

const actionTypes = {
  UPDATE_TOPIC: 'UPDATE_TOPIC',
  CREATE_TOPIC: 'CREATE_TOPIC',
  REMOVE_TOPIC: 'REMOVE_TOPIC',
  TOPIC_UPDATE_TAGS: 'TOPIC_UPDATE_TAGS',
  ACADEMY_COURSE_UPDATE_TOPIC: 'ACADEMY_COURSE_UPDATE_TOPIC',
}

const mutationTypes = {
  SET_UPDATING: 'SET_UPDATING',
  SET_CREATING: 'SET_CREATING',
  SET_REMOVING: 'SET_REMOVING',
}

export const state = () => ({
  updating: false,
  creating: false,
  removing: false,
  tags: [
    { id: 1, name: 'Child Development' },
    { id: 2, name: 'Curriculum and Pedagogy' },
    { id: 3, name: 'Learning Environment' },
    { id: 4, name: 'Interactions and Relationships' },
    { id: 5, name: 'Health, Safety and Nutrition' },
    { id: 6, name: 'Family and Community Partnerships' },
    { id: 7, name: 'Professional Mastery' },
    { id: 8, name: 'Professional Values and Ethics' },
    { id: 9, name: 'Teamwork and Collaboration' },
    { id: 10, name: 'Visioning and Planning' },
  ],
})

export const mutations = {
  [mutationTypes.SET_UPDATING](state, updating) {
    state.updating = updating
  },
  [mutationTypes.SET_CREATING](state, creating) {
    state.creating = creating
  },
  [mutationTypes.SET_REMOVING](state, removing) {
    state.removing = removing
  },
}

export const actions = {
  async [actionTypes.ACADEMY_COURSE_UPDATE_TOPIC]({ commit }, params) {
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      const { data } = await apolloClient.mutate({
        mutation: ACADEMY_COURSE_UPDATE_TOPIC,
        variables: {
          ...params,
        },
      })
      return { data, success: true }
    } catch (error) {
      return { error, success: false }
    }
  },
  async [actionTypes.UPDATE_TOPIC]({ commit }, params) {
    commit(mutationTypes.SET_UPDATING, true)
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      const { data } = await apolloClient.mutate({
        mutation: UPDATE_TOPIC,
        variables: {
          ...params,
        },
      })
      commit(mutationTypes.SET_UPDATING, false)
      return { data, success: true }
    } catch (error) {
      commit(mutationTypes.SET_UPDATING, false)
      return { error, success: false }
    }
  },
  async [actionTypes.CREATE_TOPIC]({ commit }, topic) {
    commit(mutationTypes.SET_CREATING, true)
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      const { data } = await apolloClient.mutate({
        mutation: CREATE_TOPIC,
        variables: { topic },
      })
      return { data, success: true }
    } catch (error) {
      commit(mutationTypes.SET_CREATING, false)
      return { error, success: false }
    }
  },
  async [actionTypes.REMOVE_TOPIC]({ commit }, topicIds) {
    commit(mutationTypes.SET_REMOVING, true)
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      const { data } = await apolloClient.mutate({
        mutation: REMOVE_TOPIC,
        variables: { topicIds },
      })
      return { data, success: true }
    } catch (error) {
      commit(mutationTypes.SET_REMOVING, false)
      return { error, success: false }
    }
  },
  async [actionTypes.TOPIC_UPDATE_TAGS]({ commit }, params) {
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      const { data } = await apolloClient.mutate({
        mutation: TOPIC_UPDATE_TAGS,
        variables: { ...params },
      })
      return { data, success: true }
    } catch (error) {
      return { error, success: false }
    }
  },
}

export const getters = {
  updating: (state) => state.updating,
  creating: (state) => state.creating,
  removing: (state) => state.removing,
  tags: (state) => state.tags,
}
